// extracted by mini-css-extract-plugin
module.exports = {"title":"FeedFilterModal_title__2lTZ6"};